import { store } from '@/firebase'
import {
  CollectionName,
  FSTeamAuthorizedService
} from '@WombatTechnology/nitte-time-lib'
import { collection, CollectionReference, doc } from 'firebase/firestore'

export class TeamAuthorizedService {
  static doc(teamId: string, serviceId: string) {
    return doc(this.collection(teamId), serviceId)
  }

  static collection(teamId: string) {
    return collection(
      store,
      `${CollectionName.Teams}/${teamId}/${CollectionName.TeamAuthorizedServices}`
    ) as CollectionReference<FSTeamAuthorizedService>
  }
}
